export default "__VITE_ASSET__Wr57ZfmQ__"